<template>
  <div class="z-50 fixed">
    <div class="fixed bottom-3 left-3 hidden md:block">
      <notification-bar v-for="notification in notifications" :key="notification.id" :notification="notification"
        class="mt-3" />
    </div>
    <div class="fixed bottom-3 md:hidden left-1 right-1">
      <notification-bar v-for="notification in notifications" :key="notification.id" :notification="notification"
        class="mt-3" />
    </div>
  </div>
</template>

<script>
import NotificationBar from '@/components/notifications/NotificationBar.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    NotificationBar,
  },

  computed: {
    ...mapGetters({
      notifications: 'notification/notifications',
    }),
  },
};
</script>
